module.exports = __webpack_public_path__ + "static/img/chat-pass.1770f24b.png";